export const DEFAULT_TABS_ID_PREFIX = 'tabs'

export const getTabTriggerId = (prefix: string, value: string) => `${prefix}-trigger-${value}`

export const getTabContentId = (prefix: string, value: string) => `${prefix}-content-${value}`
